/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-14T15:25:43.972
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentLeaseContractTenant,
	listRentLeaseContractTenantInit,
	listRentLeaseContractTenantByAuthorizations,
	deleteRentLeaseContractTenant
} from '@api/rentmanage/RentLeaseContractTenant';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentLeaseContractTenant({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentLeaseContractTenant(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentLeaseContractTenantByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentLeaseContractTenantByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentLeaseContractTenantInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentLeaseContractTenantInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
                        state.CompoundEntities.rowFunctionAuthorization = res.rowFunctionAuthorization;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentLeaseContractTenant({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentLeaseContractTenant({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
